(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new WeakMap();
  function animate(el, frames) {
    if (!el || reduced.matches || !el.animate) return;
    animations.get(el)?.cancel();
    animations.set(el, el.animate(frames, {duration:420,easing:'cubic-bezier(.2,.75,.25,1)'}));
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);} });
  }, {threshold:.08}) : null;
  function init(root=document) {
    root.querySelectorAll('[data-fr-reveal]:not([data-fr-observed])').forEach(el => {
      el.dataset.frObserved='true';
      if(observer && !reduced.matches) observer.observe(el); else el.classList.add('is-visible');
    });
  }
  function showImage(gallery,index) {
    const images=[...gallery.querySelectorAll('[data-fr-gallery-image]')];
    index=(index+images.length)%images.length;
    gallery.dataset.frIndex=String(index);
    images.forEach((image,i)=>{image.classList.toggle('is-active',i===index);image.setAttribute('aria-hidden',String(i!==index));});
    gallery.querySelectorAll('[data-fr-thumbnail]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    gallery.querySelector('.fr-gallery-caption').textContent=images[index].alt;
  }
  document.addEventListener('click',event=>{
    const finish=event.target.closest('[data-fr-finish]');
    if(finish){const area=finish.closest('[data-fr-showcase]');area.querySelectorAll('[data-fr-photo]').forEach(img=>{const active=img.dataset.frPhoto===finish.dataset.frFinish;img.classList.toggle('is-active',active);img.setAttribute('aria-hidden',String(!active));});area.querySelectorAll('[data-fr-finish]').forEach(btn=>btn.setAttribute('aria-pressed',String(btn===finish)));}
    const thumb=event.target.closest('[data-fr-thumbnail]');
    if(thumb) showImage(thumb.closest('[data-fr-gallery]'),Number(thumb.dataset.frThumbnail));
    const step=event.target.closest('[data-fr-step]');
    if(step){const gallery=step.closest('[data-fr-gallery]');showImage(gallery,Number(gallery.dataset.frIndex)+Number(step.dataset.frStep));}
    const pause=event.target.closest('.fr-motion-toggle');
    if(pause){const paused=pause.closest('[data-fr-marquee]').classList.toggle('is-paused');pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'Play moving banner':'Pause moving banner');}
  });
  document.addEventListener('change',event=>{
    const control=event.target;
    if(!control.closest('variant-picker'))return;
    animate(control.closest('label')||control,[{transform:'scale(.94)'},{transform:'scale(1)'}]);
    const product=control.closest('product-component');
    const gallery=product?.querySelector('[data-fr-gallery]');
    const value=String(control.value||'').toLowerCase();
    if(gallery && /\b(white|black)\b/.test(value))showImage(gallery,value.includes('white')?2:0);
  });
  document.addEventListener('slideshow:select',event=>{
    if(event.target.closest('media-gallery'))animate(event.detail?.slide?.querySelector('img'),[{opacity:.5,transform:'scale(1.025)'},{opacity:1,transform:'scale(1)'}]);
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('keydown',event=>{
    const gallery=event.target.closest('[data-fr-gallery]');
    if(gallery && ['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();showImage(gallery,Number(gallery.dataset.frIndex)+(event.key==='ArrowRight'?1:-1));}
  });
  if(observer)document.documentElement.classList.add('fr-ready');
  init();
})();
